import createToolbar from './toolbar/createToolbar.js';
import { createBasePlugin, createBaseMediaPlugin, PLUGIN_DECORATION_PROPS, PLUGIN_DECORATIONS } from 'wix-rich-content-plugin-commons';
import { Component as ImageComponent } from './image-component.js';
import { IMAGE_TYPE, IMAGE_TYPE_LEGACY } from './types.js';
import { isNumber } from 'lodash';
import { DEFAULTS } from './consts.js';
import './toolbar/inline-buttons.js';
import 'wix-rich-content-editor-common';
import './modals.js';
import './toolbar/image-settings.js';
import 'react';
import 'prop-types';
import 'classnames';
import 'wix-rich-content-common';
import 'wix-rich-content-common/libs/imageUtils';
import 'wix-rich-content-ui-components';
import './style-inject.es-746bb8ed.js';
import './imageStudio/image-editor.js';
import './imageStudio/image-editor-logic.js';
import './imageStudio/image-studio-opener-loader.js';
import './icons/ImageEditorIcon.js';
import './icons/MediaReplaceIcon.js';
import './toolbar/insert-buttons.js';
import './icons/InsertPluginIcon.js';
import './image-viewer.js';
import './wixImage.js';
import '@wix/image';
import './icons/expand.js';
import './InPluginInput.js';
import 'wix-rich-content-common/dist/statics/schemas/plugin-image.schema.json';
import './image-viewer.rtlignore-4c2a6716.js';
import './classNameStrategies.js';
import 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __restKey = (key) => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const createImagePlugin = (config) => {
  var _a, _b, _d;
  const type = IMAGE_TYPE;
  const defaultPluginData = ((_a = config == null ? void 0 : config.uiSettings) == null ? void 0 : _a.disableDownload) !== void 0 ? __spreadProps(__spreadValues({}, DEFAULTS), { disableDownload: config.uiSettings.disableDownload }) : DEFAULTS;
  const PluginData = ((_b = config == null ? void 0 : config.settings) == null ? void 0 : _b.disableExpand) !== void 0 ? __spreadProps(__spreadValues({}, defaultPluginData), { disableExpand: config.settings.disableExpand }) : defaultPluginData;
  const _c = config, {
    helpers,
    t,
    anchorTarget,
    relValue,
    [type]: settings,
    uiSettings,
    isMobile,
    innerModal,
    spoilerWrapper,
    experiments
  } = _c, rest = __objRest(_c, [
    "helpers",
    "t",
    "anchorTarget",
    "relValue",
    __restKey(type),
    "uiSettings",
    "isMobile",
    "innerModal",
    "spoilerWrapper",
    "experiments"
  ]);
  return createBasePlugin(__spreadValues({
    component: createBaseMediaPlugin(ImageComponent),
    type: IMAGE_TYPE,
    legacyType: IMAGE_TYPE_LEGACY,
    pluginDecorationProps: (props, componentData) => {
      var _a2, _b2, _c2;
      const size = (_a2 = componentData.config) == null ? void 0 : _a2.size;
      const width = (_b2 = componentData.config) == null ? void 0 : _b2.width;
      let calulatedProps = props;
      if (((_c2 = componentData.src) == null ? void 0 : _c2.width) && (size === "original" || isMobile && size === "inline" && isNumber(width) && width > 150)) {
        calulatedProps = __spreadProps(__spreadValues({}, props), {
          width: componentData.src.width,
          style: __spreadProps(__spreadValues({}, componentData.src.style || {}), {
            width: componentData.src.width
          })
        });
      }
      const resizeableProps = PLUGIN_DECORATION_PROPS[PLUGIN_DECORATIONS.RESIZEABLE](calulatedProps);
      if (size === "inline") {
        return resizeableProps;
      } else if (size === "original") {
        return __spreadProps(__spreadValues({}, resizeableProps), { style: __spreadProps(__spreadValues({}, resizeableProps.style), { maxWidth: "100%" }) });
      } else {
        const _d2 = resizeableProps.style, allButWidth = __objRest(_d2, ["width"]);
        return __spreadProps(__spreadValues({}, resizeableProps), { style: __spreadValues({}, allButWidth) });
      }
    },
    componentWillReceiveDecorationProps: (props, nextProps, onPropsChange) => {
      const { width } = PLUGIN_DECORATION_PROPS[PLUGIN_DECORATIONS.RESIZEABLE](props);
      const { width: nextWidth } = PLUGIN_DECORATION_PROPS[PLUGIN_DECORATIONS.RESIZEABLE](nextProps);
      if (width !== nextWidth) {
        onPropsChange({ size: "inline", width: nextWidth });
      }
    },
    toolbar: createToolbar({
      helpers,
      anchorTarget,
      relValue,
      t,
      uiSettings,
      isMobile,
      settings,
      experiments
    }),
    helpers,
    innerModal,
    anchorTarget,
    relValue,
    settings: settings || {},
    uiSettings,
    t,
    isMobile,
    disableRightClick: (_d = config == null ? void 0 : config.uiSettings) == null ? void 0 : _d.disableRightClick,
    defaultPluginData: PluginData,
    spoilerWrapper: (settings == null ? void 0 : settings.spoiler) && spoilerWrapper
  }, rest));
};
createImagePlugin.functionName = IMAGE_TYPE;

export { createImagePlugin };
//# sourceMappingURL=createImagePlugin.js.map
